import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import JsBarcode from 'jsbarcode';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPrint } from '@fortawesome/free-solid-svg-icons';
import logoImage from '../assets/images/bgLogo.png';
import armImage from '../assets/images/armlogo.png';
import '../styles/armsform.css';

const ArmsList = () => {
    const navigate = useNavigate();
    const [gdsrEntries, setGdsrEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchEntries = async () => {
            try {
                const response = await axios.post('https://chaman.gob.pk/eac_backend/arms.php', {
                    action: 'get_records',
                });

                if (Array.isArray(response.data)) {
                    setGdsrEntries(response.data);
                } else {
                    setGdsrEntries([]);
                    console.error('Expected array but got:', response.data);
                }
            } catch (err) {
                setError('Failed to fetch Passport entries');
            } finally {
                setLoading(false);
            }
        };
        fetchEntries();
    }, []);

    const handleDelete = async (token_id) => {
        if (window.confirm(`Are you sure you want to delete the entry with Token ID: ${token_id}?`)) {
            try {
                const response = await axios.post('https://chaman.gob.pk/eac_backend/arms.php', {
                    action: 'delete',
                    token_id,
                });
                if (response.data.status === 'success') {
                    setGdsrEntries((prevEntries) => prevEntries.filter((entry) => entry.token_id !== token_id));
                    alert('Entry deleted successfully.');
                } else {
                    alert('Error deleting entry: ' + response.data.message);
                }
            } catch (error) {
                alert('Error deleting entry');
            }
        }
    };

    const handleEdit = (entry) => {
        navigate('/dashboard/edit-arms-license', { state: { entry } });
    };


    const handlePrint = async (entry) => {
        // Initialize jsPDF in landscape orientation with A4 size
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4',
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Add background logo with opacity
        doc.setGState(new doc.GState({ opacity: 0.2 }));

        // Define maximum dimensions for the background logo
        const maxWidth = 180; // Maximum width in mm
        const maxHeight = 130; // Maximum height in mm

        // Calculate aspect ratio based on known dimensions of the image
        const originalWidth = 330; // Replace with the actual width of your logo image in pixels
        const originalHeight = 280; // Replace with the actual height of your logo image in pixels
        const aspectRatio = originalWidth / originalHeight;

        let bgLogoWidth = maxWidth;
        let bgLogoHeight = maxWidth / aspectRatio;

        // Adjust if height exceeds maxHeight
        if (bgLogoHeight > maxHeight) {
            bgLogoHeight = maxHeight;
            bgLogoWidth = maxHeight * aspectRatio;
        }

        
        // Center the logo on the page
        const centerX = (pageWidth - bgLogoWidth) / 2;
        const centerY = (pageHeight - bgLogoHeight) / 2;

        // Add the image to the PDF
        doc.addImage(logoImage, 'PNG', centerX, centerY, bgLogoWidth, bgLogoHeight);


        // Reset opacity for further elements
        doc.setGState(new doc.GState({ opacity: 1 }));

        // Add top-center logo
        const logoWidth = 15; // Adjust size as needed
        const logoHeight = 20; // Adjust size as needed
        const logoX = (pageWidth - logoWidth) / 2;
        doc.addImage(armImage, 'PNG', logoX, 10, logoWidth, logoHeight);

        // Add bold and underlined heading
        doc.setFontSize(15);
        doc.setFont("helvetica", "bold");
        doc.text("FORM XVI", pageWidth / 2, 38, { align: "center" });
        const underlineWidth = doc.getTextWidth("FORM XVI");
        doc.line((pageWidth - underlineWidth) / 2, 39, (pageWidth + underlineWidth) / 2, 39); // Underline

        // Add secondary heading
        doc.setFontSize(10);
        doc.text("POSSESSION OF THE ARMS AND AMMUNITION FOR", pageWidth / 2, 45, { align: "center" });
        doc.text("GOING PURPOSE OF PROTECTION AND DISPLAY", pageWidth / 2, 50, { align: "center" });

        // Add picture placeholder on the left
        const placeholderWidth = 35; // Width of the picture placeholder in mm
        const placeholderHeight = 40; // Height of the picture placeholder in mm
        const picBoxX = 25.4; // X-coordinate for the placeholder
        const picBoxY = 40; // Y-coordinate for the placeholder

        // Draw the rectangle for the picture box
        doc.rect(picBoxX, picBoxY, placeholderWidth, placeholderHeight);

        // Add text to indicate the placeholder
        doc.setFontSize(10); // Set font size for placeholder text
        doc.text(
            "",
            picBoxX + placeholderWidth / 2, // Center the text horizontally
            picBoxY + placeholderHeight / 2, // Center the text vertically
            { align: "center" }
        );


        // Add dimensions box below picture placeholder
        // Dimensions for the box below the picture placeholder
        const dimBoxWidth = 35; // Width of the box (1 inch in mm)
        const dimBoxHeight = 50; // Height of the box (2.5 inches in mm)
        const dimBoxY = picBoxY + 45; // Y-coordinate for the box

        // Draw the dimensions box
        doc.rect(picBoxX, dimBoxY, dimBoxWidth, dimBoxHeight); // Box with specified width and height

// Add table on the right side
const tableX = 70;
const tableY = 52;

// Define column widths in points (1 inch = 72 points)
const columnWidths = [
    1.0 * 72, // First column: 2.5 inches
    0.45 * 72, // Second column: 1.3 inches
    0.35 * 72, // Third column: 1.3 inches
    0.35 * 72, // Fourth column: 1.3 inches
    0.35 * 72, // Fifth column: 1.3 inches
    0.35 * 72  // Sixth column: 1.3 inches
];

// Table headers
const headers = [
    "NAME DESCRIPTION & RESIDENCE OF THE LICENSE AND AGENT ANY",
    "QUANTITY & DESCRIPTION OF EACH KIND OF",
    "BRIEF DESCRIPTION OF ARMS",
    "NAME OF RETAINER",
    "VALIDITY OF THE LICENSE",
    "DATE ON WHICH THE LICENSE EXPIRES"
];

// Calculate the height for each header based on the number of lines
const headerHeights = headers.map((header, index) => {
    const columnWidth = columnWidths[index];
    const headerLines = doc.splitTextToSize(header, columnWidth - 4); // Leave some padding
    return headerLines.length * 7; // Height of each header cell
});

// Find the maximum header height to ensure consistency
const maxHeaderHeight = Math.max(...headerHeights);

// Draw table headers with auto-wrapping
doc.setFontSize(9);
let currentX = tableX;
headers.forEach((header, index) => {
    const columnWidth = columnWidths[index];
    const headerLines = doc.splitTextToSize(header, columnWidth - 4); // Leave some padding
    doc.rect(currentX, tableY, columnWidth, maxHeaderHeight); // Header cell border
    headerLines.forEach((line, lineIndex) => {
        doc.text(line, currentX + columnWidth / 2, tableY + 6 + (lineIndex * 6), { align: "center" });
    });
    currentX += columnWidth; // Move to the next column
});

// Draw rows with auto-wrapping for data
// Adjust currentY to bring the row closer to the header (reduce space)
let currentY = tableY + maxHeaderHeight - 2; // Adjust the position to bring the row closer

const rows = [
    ["Mr. XYZ, 123 Main St", "5 units", "Handgun", "Khan Khan", "1 year", "31-12-2025"]
];

rows.forEach(row => {
    currentX = tableX;
    const rowHeights = row.map((cell, index) => {
        const cellLines = doc.splitTextToSize(cell, columnWidths[index] - 4); // Leave some padding
        return cellLines.length * 14; // Calculate height for each cell
    });
    const maxRowHeight = Math.max(...rowHeights); // Determine the tallest cell in the row
    row.forEach((cell, index) => {
        const columnWidth = columnWidths[index];
        const cellLines = doc.splitTextToSize(cell, columnWidth - 4); // Leave some padding
        cellLines.forEach((line, lineIndex) => {
            doc.text(line, currentX + 2, currentY + 6 + (lineIndex * 6), { align: "left" }); // Left-aligned text
        });
        currentX += columnWidth; // Move to the next column
    });
    currentY += maxRowHeight; // Move to the next row
});



// Generate and open the PDF
window.open(doc.output('bloburl'));
    };


    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(gdsrEntries);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Arms License Entries');
        XLSX.writeFile(workbook, 'Arms License.xlsx');
    };

    if (loading) return <div>Loading entries...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="passport-list">
            {/* Header with Logo */}
            <header style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                {/* <img src={logoImage} alt="Logo" style={{ height: '50px', marginRight: '10px' }} /> */}
                {/* <h2>Arms Lisence List</h2> */}
            </header>

            <div className="listsearch">
                <input
                    id='lstsea'
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                {/* <button onClick={exportToExcel}>Export to Excel</button> */}
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Token ID</th>
                        <th>License No</th>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Father Name</th>
                        <th>Profession</th>
                        <th>Weapon</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {gdsrEntries
                        .filter(entry =>
                            Object.values(entry).some(value =>
                                String(value).toLowerCase().includes(searchTerm.toLowerCase())
                            )
                        )
                        .map(entry => (
                            <tr key={entry.token_id}>
                                <td>{entry.token_id}</td>
                                <td>{entry.license_no}</td>
                                <td>{entry.date}</td>
                                <td>{entry.name}</td>
                                <td>{entry.father_name}</td>
                                <td>{entry.profession}</td>
                                <td>{entry.weapon}</td>
                                <td>{entry.status}</td>
                                <td>
                                    <div className="listbuttons">
                                        <button id='lstbtn' onClick={() => handlePrint(entry)} title="Print">
                                            <FontAwesomeIcon icon={faPrint} />
                                        </button>
                                        <button id='lstbtn' onClick={() => handleEdit(entry)} title="Edit">
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button id='lstbtn' onClick={() => handleDelete(entry.token_id)} title="Delete">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button> 
                                    </div>


                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};

export default ArmsList;
